if (sessionStorage.getItem('formSubmitted')) {
    window.location.hash = "homepage-contact-form-anchor";
    sessionStorage.removeItem('formSubmitted');
}

document.getElementById('homepage-contact-form').addEventListener('submit', function() {
    sessionStorage.setItem('formSubmitted', 'true');
});
